import * as React from "react";
import styles = require("./styles.less");

interface PageDividerProps {
    children: any;
}

const PageDivider = (props: PageDividerProps) => {
    return <p className={styles.pageDivider}>
        {props.children}
    </p>;
};

export default PageDivider;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/PageDivider/PageDivider.tsx